<template>
	<div
		class="default-spacer"
		:class="{
			'default-spacer--has-border': hasBorder,
			'default-spacer--has-height': spacerHeight !== '0',
			'default-spacer--is-hero': spacerHeight === 'hero',
		}"
	></div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const hasBorder = computed(() => props.fields?.hasBorder?.value);
const spacerHeight = computed(() => props.fields?.spacerHeight?.value || "0");
</script>

<style lang="scss">
.default-spacer {
	height: v-bind(spacerHeight);
	margin: var(--spacing-10, 80px) var(--spacing-2, 16px) 0
		var(--spacing-2, 16px);

	&.default-spacer--has-border {
		margin: var(--spacing-5, 40px) var(--spacing-2, 16px);
	}

	&.default-spacer--has-height {
		margin: 0;
		padding: 0;
	}

	&.default-spacer--is-hero {
		height: calc(96dvh - 190px);

		@media (min-width: 768px) {
			height: calc(75dvh - 190px);
		}
	}
}

.default-spacer--has-border {
	border-top: 1px solid #454545;
}
</style>
